import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Outlet, useLoaderData } from "react-router-dom";

import { IOrganization, ITeam } from "@src/types/api";

import { OrganizationsProvider } from "@LeagueManagement/Organizations/contexts/OrganizationsContext";

const OrgManagementLayout = (): React.JSX.Element => {
    const { organizations, teams } = useLoaderData() as {
        organizations?: IOrganization[];
        teams?: ITeam[];
    };

    return (
        <Container
            className="py-5 orgManagement"
            data-testid="orgManagementContent"
        >
            <Row>
                <Col>
                    <OrganizationsProvider
                        organizations={organizations}
                        teams={teams}
                    >
                        <Outlet />
                    </OrganizationsProvider>
                </Col>
            </Row>
        </Container>
    );
};

export default OrgManagementLayout;
